import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=08dd520e"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports